import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "layout-content-wrapper" }
const _hoisted_2 = { class: "mx-0 white-space-pre-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "layout-footer"
}
const _hoisted_4 = { class: "grid" }
const _hoisted_5 = { class: "col-12 md:col-6" }
const _hoisted_6 = { class: "footer-bottom flex-column align-items-start sm:flex-row sm:align-items-center" }
const _hoisted_7 = { class: "mb-2 sm:mb-0" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "col-12 text-xs" }
const _hoisted_10 = {
  key: 0,
  class: "col-12"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_PrimeVueMessage = _resolveComponent("PrimeVueMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Analytics = _resolveComponent("Analytics")!
  const _component_Tawk = _resolveComponent("Tawk")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["layout-wrapper layout-sidebar layout-static", _ctx.layoutWrapperClass])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_TopBar, { onOnMenuButtonClick: _ctx.toggleMenu }, null, 8, ["onOnMenuButtonClick"]),
        _createElementVNode("div", {
          class: _normalizeClass(["layout-main", { 'layout-main-frame': _ctx.frame }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["layout-content", { 'layout-content-frame': _ctx.frame }])
          }, [
            (_ctx.user.ui_notification)
              ? (_openBlock(), _createBlock(_component_PrimeVueMessage, {
                  key: 0,
                  class: "p-message-notification",
                  severity: "success",
                  icon: "pi",
                  closable: false
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.user.ui_notification_content), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
          ], 2),
          (!_ctx.frame)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.project.name), 1),
                      (!_ctx.project.white_label)
                        ? (_openBlock(), _createElementBlock("h6", _hoisted_8, "⚙️ " + _toDisplayString(_ctx.$t('powered_by')) + " AdBison Platform", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('server_time')) + ": " + _toDisplayString(_ctx.project.server_time) + " (UTC+03:00)", 1),
                  (!_ctx.user.isAffiliate() || _ctx.user.ui_advertiser)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_router_link, {
                          class: "text-indigo-400",
                          to: "/advertising-and-refund-policy"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('advertising_and_refund_policy')), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "layout-mask modal-in",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLayoutMaskClick && _ctx.onLayoutMaskClick(...args)))
          })
        ], 2)
      ])
    ], 2),
    _createVNode(_component_Analytics, { project: _ctx.project }, null, 8, ["project"]),
    (_ctx.project.tawk_to && _ctx.user.isAffiliate())
      ? (_openBlock(), _createBlock(_component_Tawk, {
          key: 0,
          project: _ctx.project,
          user: _ctx.user
        }, null, 8, ["project", "user"]))
      : _createCommentVNode("", true)
  ], 64))
}